<ion-content>
  <div class="setup-content">
    <!-- Back Button -->
    <ion-button
      fill="clear"
      class="back-button"
      (click)="goBack()">
      <ion-icon name="arrow-back" slot="icon-only"></ion-icon>
    </ion-button>

    <!-- Main Question -->
    <h1 class="setup-question">
      {{ 'SETUP.CUSTOMIZE_EXPERIENCE' | translate }}
    </h1>

    <!-- Text Size Section -->
    <div class="preference-section">
      <h2 class="preference-title">{{ 'SETUP.TEXT_SIZE' | translate }}</h2>
      <div class="text-size-selector">
        <ion-range
          [(ngModel)]="textSize"
          (ionInput)="onTextSizeChange()"
          min="1"
          max="5"
          step="1"
          mode="ios"
          class="text-size-range">
          <ion-label slot="start">A</ion-label>
          <ion-label slot="end">A</ion-label>
        </ion-range>
        <div class="text-size-labels">
          <span class="size-label">{{ 'SETUP.SMALL' | translate }}</span>
          <span class="size-label">{{ 'SETUP.LARGE' | translate }}</span>
        </div>
      </div>
      <div class="text-preview">
        <p class="preview-text" [ngClass]="'size-' + textSize">
          {{ 'SETUP.PREVIEW_TEXT' | translate }}
        </p>
      </div>
    </div>

    <!-- Dark Mode Section -->
    <div class="preference-section">
      <h2 class="preference-title">{{ 'SETUP.THEME' | translate }}</h2>
      <ion-segment
        [(ngModel)]="darkMode"
        (ionChange)="onThemeChange()"
        mode="ios"
        class="theme-segment">
        <ion-segment-button
          [value]="false"
          class="theme-option">
          <ion-icon name="sunny" slot="start"></ion-icon>
          <ion-label>{{ 'SETUP.LIGHT_MODE' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button
          [value]="true"
          class="theme-option">
          <ion-icon name="moon" slot="start"></ion-icon>
          <ion-label>{{ 'SETUP.DARK_MODE' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>

    <!-- Continue Button -->
    <ion-button
      expand="block"
      color="success"
      class="continue-button"
      (click)="savePreferences()">
      {{ getButtonText() }}
      <ion-icon name="checkmark" slot="end"></ion-icon>
    </ion-button>
  </div>
</ion-content>
